import { HEART_EMOJI } from './constants'

export const isCurrentReaction = (reactions, currentEmoji) => {
  if (!currentEmoji) return false
  if (!Array.isArray(reactions)) return false
  if (!reactions.length) return false

  const reaction = reactions.find(elem => elem.type === 'operator')
  if (!reaction || !reaction.emoji) return false

  if (currentEmoji === HEART_EMOJI.emoji) {
    return HEART_EMOJI.list.includes(reaction.emoji)
  }

  return reaction.emoji === currentEmoji
}